<template>
    <div>
        <van-nav-bar
            title="套餐卡明细"
            left-text="返回"
            left-arrow
            @click-left="clickback"
        />
        <van-cell-group>
            <van-cell title="店铺" :value="data.shop_name" size="large" />
            <van-cell title="开卡金额" :value="data.opencard_amount" size="large" />
            <van-cell title="有效日期" :value="data.end_date" size="large" />
        </van-cell-group>
        <div class="label-title item-title">项目明细</div>
        <PackageUsedItem v-for="item in data.serviceitem_details" :key="item.id" :item_name="item.item_name" :service_date="item.service_date" :qty="item.number" :already_used="item.already_used" />
        <div class="label-title item-title">车品明细</div>
        <PackageUsedItem v-for="item in data.versionitem_details" :key="item.id" :item_name="item.item_name" :service_date="item.service_date" :qty="item.qty" :already_used="item.already_used" />
    </div>
</template>

<script>
import { NavBar, Cell, CellGroup, Collapse, CollapseItem, Col, Row } from 'vant';
import { UserCardApi } from '@/api/vip'
import { toErrorPage } from '@/utils/usePage'
import PackageUsedItem from '@/view/user/components/packageuseditem'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Col.name]: Col,
        [Row.name]: Row,
        PackageUsedItem
    },
    data() {
        return {
            id: this.$route.params.id,
            data:{
                shop_name: "",
                serviceitem_details: [],
                opencard_amount: "",
                end_date: ""
            },
            activeNames: ['1'],
            activeNames1: ['1'],
            serviceShow:false,
            versionShow:false
        }
    },
    mounted(){
        this.getCardDetail()
    },
    methods: {
        getCardDetail(){
            var that = this
            that.axios.get(UserCardApi+that.id+'/', {params:{type:0}}).then((ret) => {
                if (ret.flag) {
                    that.data = ret.details
                    that.data.end_date = this.$moment(that.data.end_date).format('YYYY-MM-DD')
                    if(that.data.serviceitem_details.length>0){
                        that.serviceShow = true
                    }
                    if(that.data.versionitem_details.length>0){
                        that.versionShow = true
                    }
                } else {
                    toErrorPage(that,'',ret.info,null)
                }
            })
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/dinnercard`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.item-title{
    margin-left:4%;
    font-size: 1em;
    font-weight: bold;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
}
</style>